import * as React from "react";
import { CarWizardState } from "src/stores/wizard/state";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../l10n";
import { UitkHeading } from "uitk-react-text";
import { couponCodeTypes } from "./CouponCodeTypes";
import { CarVendorInformation, CarTypeInformation } from "src/stores/wizard/config/staticConfigs/car/typings";

export const CarType = (carWizardState: CarWizardState) => {
  const { formatText } = useLocalization();
  const { cars, carType } = carWizardState.config;
  const carValue = Object.values(cars).filter(({ carCode }: CarTypeInformation) => carCode === carType);

  if (carValue.length === 0) return <></>;

  carWizardState.carType = formatText(carValue[0].locKey);
  const searchKey = `["${carValue[0].carCode.toLowerCase()}"]`;

  return (
    <div>
      <UitkHeading level={4} size={300}>
        {formatText(locKeys.carType)}:{" "}
      </UitkHeading>
      <input type="text" data-testid="car-type" value={carWizardState.carType} />
      <input type="hidden" name="selCC" value={searchKey} />
    </div>
  );
};

export const CarVendorName = (carWizardState: CarWizardState) => {
  const { formatText } = useLocalization();
  const { vendors, carVendorName } = carWizardState.config;
  const vendorName = Object.values(vendors).filter(
    ({ locKey }: CarVendorInformation) => formatText(locKey) === carVendorName
  );
  carWizardState.setPreferredBrandWithoutSelect(vendorName[0].vendorCode);

  return (
    <div>
      <UitkHeading level={4} size={300}>
        {formatText(locKeys.brandSelectionLabel)} :{" "}
      </UitkHeading>
      <input type="text" data-testid="vendor-name" value={formatText(vendorName[0].locKey)} />
      <input type="hidden" name="vend" value={carWizardState.preferredBrand} />
    </div>
  );
};

export const CarDiscountType = (carWizardState: CarWizardState) => {
  const { formatText } = useLocalization();
  const { corporateCode, specialCode, noCode, couponCodeSelectionLabel } = locKeys;
  const { CORPORATE_CODE, SPECIAL_CODE, NO_CODE } = couponCodeTypes;
  const { carDiscountTypeCode } = carWizardState.config;
  const couponCode = carDiscountTypeCode === "" ? NO_CODE : carDiscountTypeCode === "1" ? CORPORATE_CODE : SPECIAL_CODE;
  carWizardState.updateCouponCodeTypeWithoutSelect(couponCode);

  return (
    <div>
      <UitkHeading level={4} size={300}>
        {formatText(couponCodeSelectionLabel)} :{" "}
      </UitkHeading>
      <input
        type="text"
        data-testid="coupon-type"
        value={
          carDiscountTypeCode === ""
            ? formatText(noCode)
            : carDiscountTypeCode === "1"
            ? formatText(corporateCode)
            : formatText(specialCode)
        }
      />
    </div>
  );
};
